import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { myNotifications, saveMyNotifications, type TPersonalPatch } from '../../entities/user';

const KEY = ['notifications', 'me'];

// Saves on the switch, like the organization matrix beside it. The Account screen used to
// collect these into its own Save button — two stories about what got written, on two screens.
export const useNotificationPreferences = () => {
  const client = useQueryClient();

  const settings = useQuery({ queryKey: KEY, queryFn: myNotifications });

  const save = useMutation({
    mutationFn: (patch: TPersonalPatch) => saveMyNotifications(patch),
    onSuccess: (next) => client.setQueryData(KEY, next),
  });

  const toggle = (category: string, channel: 'in_app' | 'email', enabled: boolean) =>
    save.mutate({ [category]: { [channel]: enabled } });

  return { settings, save, toggle };
};

export type TNotificationPreferences = ReturnType<typeof useNotificationPreferences>;
